import router from './../router'
import Auth0Lock from 'auth0-lock'

export default class AuthService {
  lock = new Auth0Lock(process.env.VUE_APP_AUTH0_CLIENT_ID, process.env.VUE_APP_AUTH0_DOMAIN,
    {
      // allowSignUp: false,
      // loginAfterSignUp: false,
      configurationBaseUrl: 'https://cdn.eu.auth0.com',
      autoclose: true,
      auth: {
        responseType: 'token id_token',
        // redirect: true,
        redirectUrl: window.location.origin,
        sso: true,
        autoclose: true,
        params: {
          audience: process.env.VUE_APP_AUTH0_AUDIENCE,
          scope: 'openid profile email client_credentials'
        }
      },
      theme: {
        primaryColor: '#3A99D8',
        logo: require('../assets/logo_tr_toolbox.png')
      }
    })

  onAuthenticated () {
    this.lock.on('authenticated', (authResult) => {
      localStorage.setItem('id_token', authResult.idToken)
      localStorage.setItem('accessToken', authResult.accessToken)
      localStorage.setItem('expiresIn', authResult.expiresIn * 1000 + new Date().getTime())
      this.lock.getUserInfo(authResult.accessToken, async (error, profile) => {
        if (error) {
          // Handle error
          return
        }
        // Set the token and user profile in local storage
        localStorage.setItem('profile', JSON.stringify(profile))

        try {
          await this.$apollo.resetStore()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('%cError on cache reset (login)', 'color: orange;', e.message)
        }

        // router.replace('/e-commerce-pulse')
        // window.location.href = window.location.href
        router.replace('/')
        window.location.href = window.location.origin
      })
    })
    // this.lock.on('authorization_error', (error) => {
    //   // handle error when authorizaton fails
    // })
  }

  login () {
    this.lock.show()
  }

  clearLocalStorage () {
    localStorage.removeItem('id_token')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('expiresIn')
    localStorage.removeItem('profile')
  }

  async logout () {
    // Clear access token and ID token from local storage
    this.clearLocalStorage()

    try {
      await this.$apollo.resetStore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
    }
    // redirect to / because this is the   authorised callback url on auth0
    window.location.href = window.location.origin
  }

  isAuthenticated () {
    return new Date().getTime() < localStorage.getItem('expiresIn') && localStorage.getItem('accessToken')
  }
}
